















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TextRuleType } from '@/components/atoms/neon/CustomTextField.vue';
import { i18n } from '@/plugins/i18n/i18n';

@Component
export default class Dropdown extends Vue {
  @Prop()
  private options!: [string];

  @Prop({ required: false, default: '' })
  private sampleInput!: string;

  @Prop()
  private isMultiple!: boolean;

  @Prop({ required: false, default: false })
  private isRequired!: boolean;

  private ruleInputRequired = i18n.tc('portal.ruleInputRequired');

  private rules: { [key: string]: TextRuleType } = {
    required: value =>
      !this.isRequired || (value && value.length > 0) || this.ruleInputRequired,
  };
}
